import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

export function QrImage({ value, size = 128 }: { value: string; size?: number }) {
  const [dataUrl, setDataUrl] = useState<string>('');

  useEffect(() => {
    let active = true;
    void QRCode.toDataURL(value, { width: size, margin: 1, color: { dark: '#2b2723', light: '#fbf7f0' } }).then(
      (url) => {
        if (active) setDataUrl(url);
      }
    );
    return () => {
      active = false;
    };
  }, [value, size]);

  if (!dataUrl) return <div style={{ width: size, height: size }} />;
  return <img src={dataUrl} width={size} height={size} alt="QR" style={{ borderRadius: 8 }} />;
}
